module.exports = __webpack_public_path__ + "static/media/biz-staff_320.8ad7ff91.jpg";